import React, { useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

const LoggedOut = () => {
  useEffect(() => {
    // Redirect to home after 3 seconds
    const timer = setTimeout(() => {
      window.location.href = '/';
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8f9fa',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '3rem 2rem',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '90%'
      }}>
        <h1 style={{
          color: '#2c3e50',
          fontSize: '1.75rem',
          fontWeight: '600',
          marginBottom: '1rem'
        }}>
          You've been logged out
        </h1>
        
        <p style={{
          color: '#6c757d',
          fontSize: '1rem',
          marginBottom: '2rem',
          lineHeight: '1.5'
        }}>
          Thank you for using LostLogic. You have been successfully logged out of your account.
        </p>

        <LoadingSpinner message="Redirecting to home..." />

        <div style={{
          marginTop: '2rem',
          paddingTop: '2rem',
          borderTop: '1px solid #e9ecef'
        }}>
          <a 
            href="/"
            style={{
              color: '#1abc9c',
              textDecoration: 'none',
              fontSize: '0.95rem',
              fontWeight: '500'
            }}
          >
            Return to home page
          </a>
        </div>
      </div>

      <div style={{
        marginTop: '2rem',
        color: '#6c757d',
        fontSize: '0.875rem'
      }}>
        <img 
          src="/img/logo/lost-logic-high-resolution-logo-transparent.png"
          alt="LostLogic"
          style={{ height: '20px', opacity: 0.6 }}
        />
      </div>
    </div>
  );
};

export default LoggedOut;